<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >

    <div>

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>
            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نوع</label>
              <v-select
                  v-model="status"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="statusOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50 w-50"
              />
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>

            <!-- Search -->
            <b-col
                cols="12"
                md="5"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="debouncedSearch"
                    class="d-inline-block mr-1"
                    placeholder="جستجو ..."
                />
              </div>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-md-0"
            >
              <b-button
                  variant="success"
                  class=""
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="downloadFile"
              >
                دانلود اکسل لیست
              </b-button>
            </b-col>
          </b-row>

          <b-row class="mt-2">

            <b-col
                cols="12"
                md="4"
                class="d-flex align-items-center justify-content-start "
            >
              <label class="mr-1">تاریخ واریز : </label>
              <input
                  type="text"
                  id="startPaymentDate"
                  :value="createJalaliDate(startPaymentDate)"
                  class="form-control p-0 form-control-lg mx-auto block w-75 rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              />
              <custom-date-picker
                  v-model="startPaymentDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY/jMM/jDD"
                  element="startPaymentDate"
                  type="date"
                  color="#5c6bc0"
                  simple
                  class="position-absolute p-0"
              ></custom-date-picker>
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start "
            >
              <label class="mr-1">تا : </label>
              <input
                  type="text"
                  id="endPaymentDate"
                  :value="createJalaliDate(endPaymentDate)"
                  class="form-control p-0 form-control-lg mx-auto block w-75 rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              />
              <custom-date-picker
                  v-model="endPaymentDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY/jMM/jDD"
                  element="endPaymentDate"
                  type="date"
                  color="#5c6bc0"
                  simple
                  class="position-absolute p-0"
              ></custom-date-picker>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start "
            >
              <b-button
                  variant="warning"
                  @click="getReceipts"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              >
                جستجو با تاریخ
              </b-button>
            </b-col>
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                cols="12"
                md="3"
            >
              <label>سفارش برای دیگری</label>
              <v-select
                  v-model="forOther"
                  :clearable="false"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="forOtherOption"
                  :reduce="val => val.value"
                  class="per-page-selector d-inline-block mx-50 w-50"
              />
            </b-col>

          </b-row>

          <!--          <b-row class="mt-2">-->
          <!--            <b-col-->
          <!--                cols="12"-->
          <!--                md="2"-->
          <!--                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"-->
          <!--            >-->
          <!--              <span>تعداد فیشات درگاه : </span>-->
          <!--              <span class="mx-1" >{{  notPurchasedByAdmin }}</span>-->
          <!--            </b-col>-->
          <!--          </b-row>-->
        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="receipts"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >

          <!--          &lt;!&ndash; Column: userInfo &ndash;&gt;-->
          <!--          <template #cell(userInfo)="data">-->
          <!--            <span v-if="data.item.userInfo !== null">{{ data.item.userInfo.name }}  {{ data.item.userInfo.familyName }}</span>-->
          <!--          </template>-->

          <!-- Column: sumPrice -->
          <template #cell(orderPrice)="data">
            <span>
               {{ makePrettyPrice(data.item.orderPrice) }} تومان
            </span>
          </template>

          <template #cell(discount)="data">
            <span v-if="data.item.orderDiscountPrice">
               {{ makePrettyPrice(data.item.orderDiscountPrice) }} تومان
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(finalPrice)="data">
            <span>
               {{ makePrettyPrice(data.item.finalPrice) }} تومان
            </span>
          </template>

          <!-- Column: createDate -->
          <template #cell(createDate)="data">
            <span>
              {{ data.item.createDate.slice(11, 16) }}
              -
              {{ createJalaliDate(data.item.createDate.slice(0, 10)) }}
            </span>
          </template>

          <!-- Column: paymentDates -->
          <template #cell(paymentDates)="data">
            <span>
              {{
                new Date(data.item.paymentDates.split(',')[0]).toLocaleDateString('fa-IR') + ' - ' + new Date(data.item.paymentDates.split(',')[0]).toLocaleTimeString('fa-IR')
              }}
            </span>
          </template>


          <template #cell(status)="data">
            <span v-if="data.item.status === 1">در صف انتظار</span>
            <span class="text-danger" v-if="data.item.status === 2">رد شده</span>
            <span v-if="data.item.status === 3">تایید شده</span>
            <span class="text-success" v-if="data.item.status === 4">تایید شده توسط حسابدار</span>
          </template>
          <template #cell(isForOtherUser)="data">
            <span v-if="data.item.isForOtherUser"
                  class="align-middle">فردی دیگر</span>
            <span v-else class="align-middle">خودِ فرد</span>
          </template>

          <!-- Column: Actions -->
          <template #cell(delete)="data">

            <b-link v-b-modal.modal-delete @click="showModal(data.item.id)">
              <feather-icon icon="TrashIcon" class="text-danger" size="20"/>
            </b-link>

          </template>

          <template #cell(edit)="data">

            <b-link :to="{ name: 'apps-receipts-info', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" size="20"/>
            </b-link>

          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <QueriedPagination v-if="totalCounts" v-model="currentPage" :total-counts="totalCounts"
                                 :per-page="perPage"></QueriedPagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
    <b-modal
        id="modal-delete"
        centered
        ok-title="حذف"
        cancelTitle="انصراف"
        @ok="deleteReceipt(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {BButton, BCard, BCol, BFormInput, BLink, BModal, BOverlay, BPagination, BRow, BTable,} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Helper from "@/libs/Helper";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {PaymentReceiptDeleteRequest, PaymentReceiptGetAllRequest} from "@/libs/Api/PaymentReciept";
import axiosIns from "@/libs/axios";
import {saveAs} from 'file-saver';
import {getUserData} from "@/auth/utils";
import QueriedPagination from "@/views/components/QueriedPagination.vue";


export default {
  name: "receiptsList",
  title: "لیست فیش‌ ها - پنل ادمین لنزآوا",
  data() {
    return {
      receipts: null,
      deleteItem: null,
      currentPage: 1,
      totalCounts: null,
      perPage: 10,
      overlay: false,
      purchasedByAdmin: 0,
      notPurchasedByAdmin: null,
      searchPurchasedByAdmin: null,
      timeOut: null,
      forOther: null,
      statusOptions: [
        {label: 'همه', value: null},
        {label: 'در صف انتظار', value: 1},
        {label: 'رد شده', value: 2},
        {label: 'تایید شده', value: 3},
        {label: 'تایید شده توسط حسابدار', value: 4},
      ],
      forOtherOption: [
        {label: 'همه', value: null},
        {label: 'برای دیگری', value: true},
        {label: 'برای خود فرد', value: false},
      ],
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        {key: 'id', label: 'شناسه فیش'},
        {key: 'fullName', label: 'اطلاعات کاربر'},
        {key: 'productTitles', label: 'نام محصول'},
        {key: 'mobile', label: 'موبایل کاربر'},
        {key: 'nationalCode', label: 'کد ملی'},
        // { key: 'description' ,label :'توضیحات'},
        {key: 'orderPrice', label: 'مبلغ سفارش'},
        {key: 'discount', label: 'مبلغ تخفیف'},
        {key: 'finalPrice', label: 'قیمت نهایی'},
        {key: 'createDate', label: 'تاریخ ثبت'},
        {key: 'paymentDates', label: 'تاریخ واریز'},
        {key: 'trackingCodes', label: 'شناسه واریز'},
        {key: 'isForOtherUser', label: 'خریدار'},
        {key: 'status', label: 'وضعیت'},
        // { key: 'delete',label:'حذف فیش'},
        {key: 'edit', label: 'نمایش فیش'},
      ],
      status: null,
      searchQuery: '',
      isAddNewUserSidebarActive: false,
      secondSearch: '',
      startPaymentDate: '',
      endPaymentDate: '',
    }
  },
  async created() {
    if (this.$route.query.pageNumber) {
      this.currentPage = +this.$route.query.pageNumber
    }
    await this.getReceipts()
  },
  methods: {
    async getReceipts() {
      let _this = this;
      _this.overlay = true;

      let data = {
        pageNumber: _this.currentPage,
        count: _this.perPage,
        search: _this.searchQuery,
        status: _this.status,
        trackingCode: _this.secondSearch,
        startPaymentDate: _this.startPaymentDate,
        endPaymentDate: _this.endPaymentDate,
        forOther: _this.forOther ?? '',
      }

      let paymentReceiptGetAllRequest = new PaymentReceiptGetAllRequest(_this);
      paymentReceiptGetAllRequest.setParams(data);
      await paymentReceiptGetAllRequest.fetch(function (content) {
        _this.overlay = false;
        _this.receipts = content.data;
        _this.totalCounts = content.total;
      }, function (error) {
        _this.overlay = false;
        console.log(error);
      })
    },
    async deleteReceipt(param) {
      let _this = this;
      _this.overlay = true;

      let paymentReceiptDeleteRequest = new PaymentReceiptDeleteRequest(_this);
      paymentReceiptDeleteRequest.setParams({id: param});
      await paymentReceiptDeleteRequest.fetch(function (content) {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `فیش حذف شد.`,
          },
        })
        _this.getReceipts()
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    // async changeReceiptstatus(orderId,status){
    //   let _this = this;
    //   _this.overlay = true;
    //   let data={
    //     orderId:orderId,
    //     status:status,
    //   }
    //
    //   let orderChangeStatusRequest = new OrderChangeStatusRequest(_this);
    //   orderChangeStatusRequest.setId(data);
    //   await orderChangeStatusRequest.fetch(function (content){
    //     _this.overlay = false;
    //     _this.$toast({
    //       component: ToastificationContent,
    //       position: 'bottom-center',
    //       props: {
    //         title: `عملیات موفق`,
    //         icon: 'CheckIcon',
    //         variant: 'success',
    //         text: `تغییرات اعمال شد.`,
    //       },
    //     })
    //     _this.getReceipts()
    //   },function (error){
    //     _this.overlay = false;
    //     console.log(error)
    //   })
    // },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    createJalaliDate(param) {
      if (param !== null && param !== '') {
        return new Date(param).toLocaleDateString("fa-IR",);
      }
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param
    },
    async downloadFile() {
      let _this = this;
      this.$store.commit('app/TOGGLE_DOWNLOAD')
      let userToken = getUserData().token;

      await axiosIns.post(`PaymentReceipt/ExportToExcel`, {
        count: this.totalCounts,
      }, {
        responseType: 'blob',
      }).then(resp => {
        saveAs(resp.data, 'لیست فیش ها.xlsx');
      }).catch((error) => {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'عملیات ناموق!',
            icon: 'CheckIcon',
            variant: 'danger',
            text: 'به علت ترافیک بالا سرور لطفا 30 دقیقه دیگر امتحان کنید',
          },
        })
      }).finally(() => {
        this.$store.commit('app/TOGGLE_DOWNLOAD')
      });
    },
  },
  watch: {
    perPage: function (nv, ov) {
      this.getReceipts();
    },
    getQuery: function (nv, ov) {
      this.getReceipts();
    },
    searchQuery: function (nv, ov) {
      this.getReceipts();
    },
    status: function (nv, ov) {
      this.getReceipts();
    },
    secondSearch: function (nv, ov) {
      this.getReceipts();
    },
    forOther(nv, ov) {
      this.getReceipts();
    },
    // searchPurchasedByAdmin(nv,ov){
    //   this.getReceipts(this.perPage,this.currentPage,this.searchQuery,nv)
    // },
  },
  computed: {
    getQuery() {
      return this.$route.query
    },
    debouncedSearch: {
      get() {
        return this.searchQuery
      },
      set(val) {
        if (this.timeOut) {
          clearTimeout(this.timeOut)
        }
        this.timeOut = setTimeout(() => {
          this.searchQuery = val
        }, 600)
      }
    }
  },
  components: {
    QueriedPagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BPagination,
    BOverlay,
    BModal,
    vSelect,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
